import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "24px_check_round" }, [
      _createElementVNode("path", {
        id: "Vector",
        d: "M12.3019 1.99813C10.3247 2.03807 8.40371 2.66339 6.78183 3.79501C5.15995 4.92663 3.91002 6.51375 3.19008 8.35569C2.47013 10.1976 2.31251 12.2117 2.73714 14.1432C3.16176 16.0747 4.14956 17.837 5.57565 19.2071C7.00174 20.5773 8.80207 21.4939 10.749 21.8409C12.696 22.188 14.7021 21.9499 16.5138 21.1569C18.3255 20.3639 19.8614 19.0515 20.9272 17.3857C21.9931 15.7199 22.5411 13.7754 22.5019 11.7981C22.4759 10.4848 22.1915 9.18953 21.6647 7.9862C21.138 6.78288 20.3794 5.69511 19.4322 4.78505C18.485 3.87498 17.3677 3.16045 16.1443 2.68226C14.9209 2.20407 13.6152 1.9716 12.3019 1.99813ZM11.5919 16.4281L7.50195 12.5181L8.90195 11.0781L11.5019 13.6081L16.9719 7.90813L18.4419 9.29813L11.5919 16.4281Z",
        fill: "#333333"
      })
    ], -1)
  ]))]))
}
export default { render: render }